

















































































import * as Vue from '@vue/composition-api'
import firebase from '@/ts/apis/firebase'

export default Vue.createComponent({
  name: 'App',
  setup (props, ctx) {
    Vue.onMounted(async () => {
      const result = await firebase.auth().getRedirectResult()
      console.log('getRedirectResult', result)
      ctx.root.$store.dispatch('user/init')
    })
    return {
    }
  }
})
